// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__jFUhg","cell":"ColumnAccessor_cell__3mnXl","firstCellAccent":"ColumnAccessor_firstCellAccent__1jO33"};